<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Templates de Orçamentos</h3>
        <router-link class="btn btn-success text-white float-right" :to="{ name: 'admin-quotation-template-new' }">Novo template</router-link>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-2">
              <h6 class="m-0">Modelos</h6>
            </div>
            <div class="col-10">
              <d-form action="#" class="w-100">
                <d-form-row class="justify-content-end">
                   <!-- Type -->
                  <d-col cols="12" md="2" class="form-group">
                    <d-select v-model="pagination.typeId">
                      <option :value="option.id" v-for="(option, index) in typeOptions" :key="index">{{ option.name }}</option>
                    </d-select>
                  </d-col>
                  <d-col cols="12" md="4">
                    <div class="input-group input-group-seamless ml-3">
                      <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fas fa-search"></i></div>
                      </div>
                      <input
                        class="navbar-search form-control"
                        type="text"
                        placeholder="Procurar por algo..."
                        aria-label="Search"
                        v-model="pagination.search"
                      >
                    </div>
                  </d-col>
                </d-form-row>
              </d-form>
            </div>
          </div>
          <div class="card-body p-0 pb-3">
            <div class="table-overflow">
              <quotation-table :templates="templates.list"></quotation-table>
            </div>
            <pagination :total-items="templates.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import QuotationTable from '../components/QuotationTemplateTable.vue';
import { TYPE_OPTIONS } from '../components/QuotationModel';

export default {
  name: 'quotation-template-list',
  components: {
    Pagination,
    QuotationTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        typeId: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    templates() {
      const { templateList } = this.$store.state.quotation;
      if (templateList && templateList.list.length) {
        return templateList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    typeOptions() {
      const { typeOptions } = this.$store.state.quotation;
      if (typeOptions && typeOptions.length) {
        return [{ id: null, name: 'Tipo de projeto' }, ...typeOptions];
      }
      return TYPE_OPTIONS;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTemplateList',
      'getTypeOptions',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getTemplateList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    getOptions() {
      if (!this.$store.state.quotation.typeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
</style>
